<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
            >&laquo; Back</md-button>
          </md-layout>
          <!-- <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2 style="text-align:center">Custom Clearance Quotation</h2>
          </md-layout>-->
        </md-layout>

        <div v-if="(checkModule.indexOf('CC')>=0)">
          <!-- /.box-header v-if="ffTableArry.length>0" -->
          <div class="box-body">
            <hr class="hr-s" />
            <div class="box-header">
              <h5 class="box-title">
                <u>Existing CC Quotation</u>
              </h5>
              <md-button
                @click="openCC"
                v-if="hideButtn==false"
                class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
              >New CC Quotation</md-button>
            </div>
            <table id="cc" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr no</th>
                  <th>CC Quotation</th>

                  <th>Approval Status</th>

                  <!-- <th>Action</th> -->
                  <th>Action</th>

                  <th>Print</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1,index) in ccTableArry" :key="index">
                  <td>{{index+1}}</td>

                  <td
                    :style="index==0?'color:green':'color:red'"
                    class="showMoreData"
                    @click="editCC(item1.ccQId)"
                  >
                    <b>Quotation No. :</b>
                    {{item1.ccQSeries}}
                    <br />
                    <b>Validity Date :</b>
                    {{item1.validityDate | moment}}
                    <br />
                    <span class="error">{{item1.ccExpireStatus==1?" (Expired)":""}}</span>
                  </td>

                  <td>
                    <b>Manager Approval :</b>
                    {{item1.ccStatus=='0'?'Pending':item1.ccStatus=='1'?'Approved':'Rejected'}}
                    <br />
                    <b>Client Approval :</b>
                    {{item1.ccClientStatus=='0'?'Pending':item1.ccClientStatus=='1'?'Approved':'Rejected'}}
                  </td>

                  <!-- <td>{{item1.clientName}}</td> -->
                  <!-- <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="editCC(item1.ccQId)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>-->
                  <td v-if="index=='0' && item1.ccClientStatus!='2'  && item1.ccClientStatus!='1'">
                    <b v-if="item1.ccStatus!='1'   && item1.sendHODApproveCC=='1' ">
                      Sent For Approval
                      <br />
                    </b>
                    <b
                      v-else-if="item1.ccStatus=='1' && item1.sendToEnquiryCC=='0'"
                      class="showMoreData"
                      @click="openPop(item1)"
                    >
                      Send To Enquiry Team
                      <br />
                    </b>
                    <b v-else-if="item1.ccStatus=='1'  && item1.sendToEnquiryCC=='1'  ">
                      Already Sent to Enquiry
                      <br />
                    </b>
                    <b v-else>
                      N/A
                      <br />
                    </b>
                  </td>
                  <td v-else>
                    <b>
                      {{item1.ccClientStatus=='2' && index==0?"Client Rejected":item1.ccClientStatus=='1' && index==0?"Client Approved":"N/A"}}
                      <br />
                    </b>
                  </td>
                  <td>
                    <md-button
                      v-if="item1.ccQuotationPdf!='' && item1.ccQuotationPdf!=null"
                      class="md-icon-button md-raised md-dense"
                      @click="Print(item1.ccQuotationPdf)"
                    >
                      <md-icon>print</md-icon>
                    </md-button>
                    <b v-else>Pdf Not Generated</b>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- /.box-body -->
          </div>
          <hr class="hr-border" />
        </div>

        <!-- <div v-else>
          <hr class="hr-border">
          <h5 style="text-align:center;font-size:20px;color:red">Custom Clearance Not Required..!</h5>
        </div>-->
      </md-card-content>
    </md-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";

import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },

  data() {
    return {
      docURL: URL_BASE_DOC,
      isLoading: "",
      openTPTDiv: false,
      openFFDiv: false,
      openCCDiv: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok"
      },
      tptModal: {
        tptQId: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        driverExp: "",
        travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        margin: "",
        baseCost: "",
        quotRate: "",
        tptStatus: "",
        tptClientStatus: ""
      },
      ffModal: {
        mainEnquiryId: "",
        ffQId: "",
        enquiryClientId: "",
        ffType: "",
        buyingRate: "",
        ffSellingRate: "",
        shippingId: "",
        enquiryClientId: "",
        ffStatus: "",
        ffClientStatus: ""
      },
      ccModal: {
        mainEnquiryId: "",
        enquiryClientId: "",
        ccQId: "",
        ccType: "",
        ccSellingRate: "",
        ccStatus: "",
        ccClientStatus: ""
      },
      ffTypeList: [
        {
          ffTypeVal: "OceanF",
          ffTypeText: "Ocean Freight"
        },
        {
          ffTypeVal: "THC",
          ffTypeText: "THC"
        },
        {
          ffTypeVal: "RailF",
          ffTypeText: "Rail Freight"
        },
        {
          ffTypeVal: "LHC",
          ffTypeText: "Local Handling Charges"
        }
      ],
      ccList: [
        {
          ccTypeVal: "CC_Charges",
          ccTypeText: "Custom Clearance Charges"
        },
        {
          ccTypeVal: "LH_Charges",
          ccTypeText: "Local Handling Charges"
        }
      ],
      statusList: [
        {
          statusV: "1",
          statusT: "Approve"
        },
        {
          statusV: "2",
          statusT: "Reject"
        }
      ],
      hideButtn: false,
      newData: {
        ccQId: "",
        mainEnquiryId: "",
        ccQSeries: "",
        ccQuotationPdf: ""
      },

      checkModule: [],
      enquiryArry: [],
      tptTableArry: [],
      ffTableArry: [],
      ccTableArry: [],
      shippingList: []
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },

  computed: {},

  methods: {
    Print(item) {
      window.open(`${this.docURL}/CC_QUOTATION_PDF/` + item);
    },
    sendMail(type) {
      this.newData["jobType"] = "CC";
      if (type != "cancel") {
        this.isLoading = true;
        if (this.validate != false) {
          // $("#addButtonLoaderS").css("display", "none");
          // $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Enquiry/sendForClientTPT_VP.php`,
            data: JSON.stringify(this.newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              // $("#loaderS").css("display", "none");
              // $("#addButtonLoaderS").css("display", "block");

              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.isLoading = false;
              this.getData();
              // this.$router.push({
              //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
              // });
            })
            .catch(error => {});
        }
      }
    },
    openPop(item) {
      Object.keys(this.newData).map(x => {
        this.newData[x] = item[x] || "";
      });

      this.alert.content = "Send Mail To Enquiry Team..?";

      this.$refs["popMail"].open();
    },
    openTPT() {
      this.openTPTDiv = true;
    },
    openFF() {
      this.openFFDiv = true;
    },
    openCC() {
      this.$sessionsStorage.set("editccQId", "");
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotationCC"
      });
    },

    finalbasecost() {
      let driverExpensenew =
        parseFloat(this.tptModal.driverExp) *
        parseFloat(this.tptModal.travelDur);

      let averageTrucknew =
        parseFloat(this.tptModal.distance) / parseFloat(this.tptModal.mileage);

      let dieselRatenew =
        parseFloat(averageTrucknew) * parseFloat(this.tptModal.dieselRate);
      let basefinalcost =
        parseFloat(dieselRatenew) +
        parseFloat(driverExpensenew) +
        parseFloat(this.tptModal.toll);
      this.tptModal.baseCost = basefinalcost.toFixed(2);

      let finalSalesCost =
        (parseFloat(this.tptModal.baseCost) *
          parseFloat(this.tptModal.margin)) /
        100;
      let finalSalesCost2 = finalSalesCost + parseFloat(this.tptModal.baseCost);
      this.tptModal.quotRate = finalSalesCost2.toFixed(2);
    },
    addGenerateQuotation(ID) {
      // this.validateFFExport();

      this.tptModal["mainEnquiryId"] = this.$sessionsStorage.get(
        "editMainEnqId"
      );
      this.ffModal["mainEnquiryId"] = this.$sessionsStorage.get(
        "editMainEnqId"
      );
      this.ccModal["mainEnquiryId"] = this.$sessionsStorage.get(
        "editMainEnqId"
      );

      let newData = {
        TPTModal: this.tptModal,
        FFModal: this.ffModal,
        CCModal: this.ccModal,
        buttonId: ID
      };
      console.log(newData);

      if (this.validate != false) {
        // $("#addButtonLoader").css("display", "none");
        // $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainQuotation.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            this.getData();
            if (ID == "1") {
              Object.keys(this.tptModal).map(x => {
                this.tptModal[x] = "";
              });
            }
            if (ID == "2") {
              Object.keys(this.ffModal).map(x => {
                this.ffModal[x] = "";
              });
            }
            if (ID == "3") {
              Object.keys(this.ccModal).map(x => {
                this.ccModal[x] = "";
              });
            }
            this.openTPTDiv = false;
            this.openFFDiv = false;
            this.openCCDiv = false;
          })
          .catch(error => {});
      }
    },
    previousFFView() {
      this.$router.push({
        path: "/viewMainEnquiryDetails/viewMainEnquiryDetails"
      });
    },

    JqueryFun() {
      return $(function() {
        $("#tpt").DataTable();
        $("#ff").DataTable();
        $("#cc").DataTable();
      });
    },

    editTPT(item) {
      Object.keys(this.tptModal).map(x => {
        this.tptModal[x] = item[x];
      });
      this.openTPTDiv = true;
    },
    editFF(item) {
      Object.keys(this.ffModal).map(x => {
        this.ffModal[x] = item[x];
      });
      this.openFFDiv = true;
    },
    editCC(item) {
      this.$sessionsStorage.set("editccQId", item);
      this.$router.push({
        path: "/mainEnquiry/mainEnqQuotationCC"
      });
    },

    getData() {
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : ""
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getDataMainQuot.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            console.log(data);
            if (data.enquiryData.length > 0) {
              this.enquiryArry = data.enquiryData;
              this.ffModal.enquiryClientId = data.enquiryData[0].clientId;
              this.ffModal.enquiryClientId = data.enquiryData[0].clientId;
              this.ccModal.enquiryClientId = data.enquiryData[0].clientId;
              this.checkModule = data.enquiryData[0].jobType.split(",");
              console.log(this.checkModule, "0i098");
            } else {
              this.enquiryArry = [];
            }
            if (data.tptData.length > 0) {
              this.tptTableArry = data.tptData;
            } else {
              this.tptTableArry = [];
            }
            if (data.ffData.length > 0) {
              this.ffTableArry = data.ffData;
            } else {
              this.ffTableArry = [];
            }
            if (data.ccData.length > 0) {
              this.ccTableArry = data.ccData;
              let arryStatus = this.ccTableArry.filter(x => {
                return x.ccClientStatus == "1";
              });

              if (arryStatus.length > 0) {
                this.hideButtn = true;
              }
            } else {
              this.ccTableArry = [];
            }

            if (data.slineDetails.length > 0) {
              this.shippingList = data.slineDetails;
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
</style>




// WEBPACK FOOTER //
// viewMainEnqQuotationCC.vue?a7ca628e